module.exports = __webpack_public_path__ + "static/L2_content_user_input_5_dont-3217a5b981ce07a0c9f02a922c66817f.png";